import { render, staticRenderFns } from "./show3.vue?vue&type=template&id=48faf9db&scoped=true&"
import script from "./show3.vue?vue&type=script&lang=js&"
export * from "./show3.vue?vue&type=script&lang=js&"
import style0 from "./show3.vue?vue&type=style&index=0&id=48faf9db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48faf9db",
  null
  
)

export default component.exports